import { SET_BINOMIAL_ALPHA } from './types';

const binomialAlpha = (state = null, action) => {
  switch (action.type) {
    case SET_BINOMIAL_ALPHA:
      return action.binomialAlpha;
    default:
      return state;
  }
};

export default binomialAlpha;
